var $ffeb8be3b805c9ef$exports = {};
$ffeb8be3b805c9ef$exports = {
    "pending": `pendente`
};


export {$ffeb8be3b805c9ef$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
